<div *ngIf="vendorBatchRequestData; else loading" class="wrapper has-padding">
  <!-- set focus when pressing skiplink button -->
  <div tabindex="-1" #vendorBatchElement class="bofa--skiplink">
  </div>
  <h2 class="bofa--heading is-5">Contractor Background Investigation Request</h2>
  <form [formGroup]="vendorBatchRequestForm" class="bottom-space">
    <div>
      <mat-card appearance="outlined" class="af-mat-card mat-elevation-z" role="group">
        <mat-card-header>
          <mat-card-title>
            <h3 class="bofa--heading is-6">Upload file</h3>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="shift">
            <button type="button" class="bofa--button secondary outlined" title="Download Batch Upload Template" 
            aria-label="download Batch Upload Template" 
            (click)="downloadAttachment('62', 'Batch_Upload_Template.xlsx')">Batch Upload Template
            </button>                  
          </div>

          <div class="flex-row-wrap">
            <div class="bofa--skiplink display-none" id="upload" aria-hidden="true">Upload file</div>
            <input aria-labelledby="upload" tabindex="0" type="file" id="fileUpload" #fileUpload name="fileUpload"
              accept=".xls,.xlsx" aria-hidden="true" class="display-none" />

            <p class="margin-right">File Name:</p>

            <button type="button" class="bofa--button secondary outlined ui-font" (click)="onClick()">
              {{text}}
            </button>

            <p class="margin-right" *ngIf="files.length == 0"> Please select a file</p>

            <div class="flex-row-wrap-file margin-right" *ngFor="let file of files">
              <p tabindex="-1" #addedFile role="alert" aria-live="polite">{{file.data.name}}</p>

              <img tabindex="0" (click)="deleteClick()" (keyup.enter)="deleteClick()"
                src="assets/bofa_icon_close2_186rgb.svg" class="remove-attachment" alt="remove attachment" role="img" />

              <mat-error class="vc-error" *ngFor="let validationError of file.validationErrors">
                {{validationError}}</mat-error>
            </div>
          </div>

          <div class="flex-row-wrap">
            <mat-form-field *ngIf="vendorMap" class="max-zoom field-space vc-field-width" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Account</mat-label>
              <mat-select formControlName="vendorAccount">
                <mat-option>Select</mat-option>
                <mat-option
                  *ngFor="let vendorAccount of vendorBatchRequestData.vendorAccountMap | keyvalue : valueAscOrder"
                  [value]="vendorAccount.key">
                  {{vendorAccount.value}}
                </mat-option>
              </mat-select>
              <mat-error>Please select Account.</mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="!vendorMap" class="max-zoom field-space vc-field-width" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Account</mat-label>
              <mat-select [formControl]="accountControl">
                <mat-option *ngFor="let account of accountArray" [value]="account.id">
                  {{account.value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="level-item">
            <button type="button" (click)="onClickSubmit()" class="bofa--button primary large ui-font"
              [disabled]="!validate()">
              Submit</button>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </form>

  <div class="table-container bottom-space">
    <span class="hide" id="tableDesc">Submitted files</span>
    <table mat-table aria-labelledby="tableDesc" [dataSource]="dataSource">
      <ng-container matColumnDef="fileName">
        <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>File Name</th>
        <td mat-cell *matCellDef="let element">
          <button type="button" class="bofa--button secondary outlined" title="Download Batch Request"
            (click)="downloadBatchRequest(element.uploadId, element.fileName)">{{element.fileName}}</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="vendorFirstName">
        <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Attached by</th>
        <td mat-cell *matCellDef="let element"> {{element.vendorFirstName}} {{element.vendorMiddleName}}
          {{element.vendorLastName}}</td>
      </ng-container>

      <ng-container matColumnDef="fileSize">
        <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Size (In Bytes)</th>
        <td mat-cell *matCellDef="let element"> {{element.fileSize}} </td>
      </ng-container>

      <ng-container matColumnDef="uploadDateString">
        <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Date attached</th>
        <td mat-cell *matCellDef="let element"> {{element.uploadDateString}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns ; "></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator aria-label="Submitted files pagination" [pageSizeOptions]="[ 10, 20 ]" showFirstLastButtons></mat-paginator>
  </div>
</div>

<ng-template #loading>
  <div class="double-top-space">
    <p>Loading Vendor batch request ...</p>
  </div>
</ng-template>